import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import styled from 'styled-components';
import PropTypes from 'prop-types';
import breakpoints from '../../utils/breakpoints';
import { HEADER_HEIGHT } from '../../utils/constants';
var Wrapper = styled.div.withConfig({
  displayName: "styled__Wrapper",
  componentId: "@frameio/developer-components__sc-9n88q3-0"
})({
  height: "".concat(HEADER_HEIGHT, "px"),
  display: 'flex',
  position: 'sticky',
  width: '100%',
  top: 0,
  backgroundColor: '#FFF',
  borderBottom: '1px solid rgba(217, 218, 227, 0.75)',
  color: '#FFF',
  zIndex: 5,
  justifyContent: 'center'
});
var DesktopNav = styled.nav.withConfig({
  displayName: "styled__DesktopNav",
  componentId: "@frameio/developer-components__sc-9n88q3-1"
})(function (props) {
  var _ref;

  return _ref = {
    visibility: 'hidden',
    maxWidth: props.maxWidth,
    justifyContent: 'space-between',
    width: '100%',
    alignItems: 'center',
    height: 'inherit',
    margin: props.columns != 1 && '0 24px !important',
    display: 'none'
  }, _defineProperty(_ref, breakpoints.xs, {
    paddingLeft: props.columns == 1 && 'var(--page-margin)',
    paddingRight: props.columns == 1 && 'var(--page-margin)'
  }), _defineProperty(_ref, breakpoints.md, {
    visibility: 'visible',
    display: 'flex'
  }), _ref;
});
var DesktopLogoWrapper = styled.div.withConfig({
  displayName: "styled__DesktopLogoWrapper",
  componentId: "@frameio/developer-components__sc-9n88q3-2"
})({
  cursor: 'pointer',
  display: 'flex',
  justifyContent: 'center',
  img: {
    padding: '2px 0 0 0',
    margin: 'auto 0 !important',
    height: '100%'
  }
});
var Actions = styled.div.withConfig({
  displayName: "styled__Actions",
  componentId: "@frameio/developer-components__sc-9n88q3-3"
})(_defineProperty({
  display: 'flex',
  paddingLeft: '0.25rem',
  alignItems: 'baseline'
}, breakpoints.sm, {
  paddingLeft: 0
}));
export { Wrapper, DesktopNav, DesktopLogoWrapper, Actions };
DesktopNav.propTypes = {
  maxWidth: PropTypes.string.isRequired
};